var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCptLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    zoomAndPan: "magnify",
    viewBox: "0 0 56.25 56.249997",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e52832d18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.351562 10.601562 L 11.042969 10.601562 L 11.042969 30.757812 L 8.351562 30.757812 Z M 8.351562 10.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b4564bad5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.484375 10.601562 L 29.175781 10.601562 L 29.175781 30.757812 L 26.484375 30.757812 Z M 26.484375 10.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75b8b453f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.164062 10.601562 L 46.855469 10.601562 L 46.855469 30.757812 L 44.164062 30.757812 Z M 44.164062 10.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8affa1ca3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.476562 7.945312 L 50.191406 7.945312 L 50.191406 10.601562 L 5.476562 10.601562 Z M 5.476562 7.945312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 847247271
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.417969 10.601562 L 20.109375 10.601562 L 20.109375 30.757812 L 17.417969 30.757812 Z M 17.417969 10.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c601426f71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.324219 10.601562 L 38.015625 10.601562 L 38.015625 30.757812 L 35.324219 30.757812 Z M 35.324219 10.601562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e52832d18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 8.351562 10.601562 L 11.09375 10.601562 L 11.09375 39.242188 L 8.351562 39.242188 Z M 8.351562 10.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b4564bad5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 26.484375 10.601562 L 29.226562 10.601562 L 29.226562 38.992188 L 26.484375 38.992188 Z M 26.484375 10.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75b8b453f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 44.164062 10.601562 L 46.902344 10.601562 L 46.902344 38.992188 L 44.164062 38.992188 Z M 44.164062 10.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8affa1ca3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 5.476562 7.945312 L 50.300781 7.945312 L 50.300781 10.6875 L 5.476562 10.6875 Z M 5.476562 7.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0847247271)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.417969 10.601562 L 20.15625 10.601562 L 20.15625 39.242188 L 17.417969 39.242188 Z M 17.417969 10.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c601426f71)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 35.324219 10.601562 L 38.066406 10.601562 L 38.066406 38.992188 L 35.324219 38.992188 Z M 35.324219 10.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.55695, 50.797689)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.75 -11.796875 C 6.632812 -11.796875 5.765625 -11.375 5.140625 -10.53125 C 4.523438 -9.6875 4.21875 -8.507812 4.21875 -7 C 4.21875 -3.863281 5.394531 -2.296875 7.75 -2.296875 C 8.738281 -2.296875 9.9375 -2.539062 11.34375 -3.03125 L 11.34375 -0.53125 C 10.1875 -0.0507812 8.898438 0.1875 7.484375 0.1875 C 5.429688 0.1875 3.859375 -0.429688 2.765625 -1.671875 C 1.679688 -2.910156 1.140625 -4.695312 1.140625 -7.03125 C 1.140625 -8.488281 1.40625 -9.769531 1.9375 -10.875 C 2.476562 -11.976562 3.25 -12.820312 4.25 -13.40625 C 5.25 -14 6.414062 -14.296875 7.75 -14.296875 C 9.125 -14.296875 10.5 -13.960938 11.875 -13.296875 L 10.921875 -10.875 C 10.390625 -11.125 9.859375 -11.335938 9.328125 -11.515625 C 8.796875 -11.703125 8.269531 -11.796875 7.75 -11.796875 Z M 7.75 -11.796875 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.12849, 50.797689)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.765625 -7.453125 L 5.75 -7.453125 C 6.664062 -7.453125 7.347656 -7.632812 7.796875 -8 C 8.253906 -8.363281 8.484375 -8.894531 8.484375 -9.59375 C 8.484375 -10.289062 8.289062 -10.804688 7.90625 -11.140625 C 7.53125 -11.472656 6.9375 -11.640625 6.125 -11.640625 L 4.765625 -11.640625 Z M 11.5 -9.6875 C 11.5 -8.175781 11.023438 -7.019531 10.078125 -6.21875 C 9.128906 -5.414062 7.785156 -5.015625 6.046875 -5.015625 L 4.765625 -5.015625 L 4.765625 0 L 1.765625 0 L 1.765625 -14.09375 L 6.265625 -14.09375 C 7.984375 -14.09375 9.285156 -13.722656 10.171875 -12.984375 C 11.054688 -12.242188 11.5 -11.144531 11.5 -9.6875 Z M 11.5 -9.6875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.516997, 50.797689)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.203125 0 L 4.21875 0 L 4.21875 -11.609375 L 0.390625 -11.609375 L 0.390625 -14.09375 L 11.03125 -14.09375 L 11.03125 -11.609375 L 7.203125 -11.609375 Z M 7.203125 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCptLight);
export default __webpack_public_path__ + "static/media/CPT_light.73770e4bb863ab3250d49cd2e6dc160f.svg";
export { ForwardRef as ReactComponent };